"use client";

import { c as _c } from "react/compiler-runtime";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { disabledVariants } from "../../styles";
import { classNames } from "../../utils";
import { FlexCenter } from "../FlexCenter";
/**
 * An input where the user selects a value from within a given range.
 */
export function Slider(t0) {
  const $ = _c(29);
  let className;
  let defaultValue;
  let disabled;
  let onValueChange;
  let props;
  let t1;
  let value;
  if ($[0] !== t0) {
    ({
      className,
      defaultValue,
      value,
      disabled,
      onValueChange,
      minStepsBetweenThumbs: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = defaultValue;
    $[3] = disabled;
    $[4] = onValueChange;
    $[5] = props;
    $[6] = t1;
    $[7] = value;
  } else {
    className = $[1];
    defaultValue = $[2];
    disabled = $[3];
    onValueChange = $[4];
    props = $[5];
    t1 = $[6];
    value = $[7];
  }
  const minStepsBetweenThumbs = t1 === undefined ? 1 : t1;
  let t2;
  if ($[8] !== className || $[9] !== disabled) {
    t2 = classNames(disabledVariants({
      disabled
    }), "w-full p-3", className);
    $[8] = className;
    $[9] = disabled;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== defaultValue) {
    t3 = defaultValue !== undefined ? [defaultValue] : undefined;
    $[11] = defaultValue;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== onValueChange) {
    t4 = t5 => {
      const [value_0] = t5;
      onValueChange?.(value_0);
    };
    $[13] = onValueChange;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== value) {
    t5 = value !== undefined ? [value] : undefined;
    $[15] = value;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SliderPrimitive.Track className={classNames("relative h-2 w-full grow overflow-hidden bg-bg-additional-2", "rounded-full")}><SliderPrimitive.Range className="absolute h-full bg-blue-3" /></SliderPrimitive.Track>;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SliderPrimitive.Thumb className={classNames("block size-4 rounded-full bg-blue-3 shadow-sm", "transition-colors")} />;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== disabled || $[20] !== minStepsBetweenThumbs || $[21] !== props || $[22] !== t3 || $[23] !== t4 || $[24] !== t5) {
    t8 = <SliderPrimitive.Root className="relative flex w-full cursor-pointer touch-none select-none items-center" defaultValue={t3} disabled={disabled} minStepsBetweenThumbs={minStepsBetweenThumbs} onValueChange={t4} value={t5} {...props}>{t6}{t7}</SliderPrimitive.Root>;
    $[19] = disabled;
    $[20] = minStepsBetweenThumbs;
    $[21] = props;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t2 || $[27] !== t8) {
    t9 = <FlexCenter className={t2}>{t8}</FlexCenter>;
    $[26] = t2;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}